import { createAction, props, union } from '@ngrx/store';

import { Company, CompanyUpdate, ContactPersonUpdate } from '@fcom/common/interfaces';

export const fetchCompany = createAction('[CompanyActions] FetchCompany');
export const setCompany = createAction('[CompanyActions] SetCompany', props<{ company: Company }>());
export const updateCompany = createAction('[CompanyActions] UpdateCompany', props<{ payload: CompanyUpdate }>());
export const updateContactPersons = createAction(
  '[CompanyActions] UpdateContactPersons',
  props<{ payload: ContactPersonUpdate }>()
);

const all = union({ fetchCompany, setCompany, updateCompany, updateContactPersons });
export type CompanyActionsUnion = typeof all;
